import { DEFAULT_LANGUAGE, RTL_LANGUAGES } from "./languages";

export const getDirection = (language = DEFAULT_LANGUAGE) =>
  RTL_LANGUAGES.includes(language) ? "rtl" : "ltr";

export default getDirection;
